import React, { useState } from 'react';
import { SiAwsorganizations } from 'react-icons/si';
import { IoEyeOutline } from 'react-icons/io5';

const ListOfOrganization = ({ organizations }) => {
  const [searchTerm, setSearchTerm] = useState('');

  // Filter organizations based on the search term
  const filteredOrganizations = organizations.filter(org =>
    org.name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <>
      <div className="list-of-organization  p-5  bg-white h-[56vh] w-[61vw] ml-3 mt-3 rounded-2xl flex flex-col border border-gray-300">
        <h1 className="text-2xl font-bold flex place-content-center">
          List of Organizations
        </h1>
        {/* Search Input */}
        <input
          type="text"
          placeholder="Search organization by name"
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
          className="p-1 mb-2 mt-2 rounded-md border border-gray-300 rounded w-full"
        />
        <div className="h-[45vh] rounded-md flex-wrap w-[100%] border border-gray-300 overflow-auto bg-customGrey mx-auto">
          <table className="w-full text-sm text-left">
            <thead className="text-xs text-black uppercase bg-white">
              <tr>
                <th scope="col" className="px-6 py-3">
                  Name
                </th>
                <th scope="col" className="px-6 py-3">
                  Code
                </th>
                {/* <th scope="col" className="px-6 py-3">
                  Procedures
                </th> */}
                <th scope="col" className="px-6 py-3">
                  External Assigned Users
                </th>
                {/* <th scope="col" className="px-6 py-3">
                  Action
                </th> */}
              </tr>
            </thead>
            <tbody>
              {filteredOrganizations.length > 0 ? (
                filteredOrganizations.map((_org, _index) => (
                  <tr key={_index} className="border-b">
                    <th
                      scope="row"
                      className="px-6 py-4 text-black font-medium whitespace-nowrap flex items-center gap-6"
                    >
                      <div className="bg-mainColor text-white w-fit rounded p-1">
                        <SiAwsorganizations className="h-5 w-5" />
                      </div>
                      {_org.name}
                    </th>
                    <td className="px-6 py-4">{_org?.code}</td>
                    {/* <td className="px-6 py-4">{_org?.procedures?.length}</td> */}
                    <td className="px-6 py-4">{_org?.users?.length}</td>
                    {/* <td className="px-6 py-4">
                      <IoEyeOutline size={24} className="text-mainColor" />
                    </td> */}
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="2"
                    className="px-6 py-4 text-center text-gray-500"
                  >
                    No organizations found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default ListOfOrganization;
